module.exports = {
  GOOGLE: 'google',
  SKOLETUBE: 'skoletube',
}
